export default __webpack_public_path__ + "Logo-Transparent-Horizontal.jpg";